import { useState } from 'react';
import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import {
    Close as CloseIcon,
    Download as DownloadIcon
} from '@mui/icons-material';

// embedded means with the browser native viewer
export default function IframeViewer({open, url, title, disclaimer, download, downloadFile, fullScreen, handleClose}){
	
	const { sxDialogFileViewer, sxDialogContentFileViewer } = getModalStyle();

	const [ isLoading, setIsLoading ] = useState(open);

    // Function to run when the iframe content finishes loading
    const handleLoad = () => {
        setIsLoading(false);
    };

	return (
		<Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialogFileViewer}
            onClose={handleClose}
            open={open}
            fullWidth={true}
            fullScreen={true}
            maxWidth='lg'
        >
            {
                title && title?.length > 0 &&
                <DialogTitle className='modal-title-urlviewer w-full truncate'>
                    {title}
                </DialogTitle>
            }
            <DialogContent sx={sxDialogContentFileViewer}>
            	{
                    isLoading &&
                    <Backdrop
                        sx={{ position: 'relative', height: '100%', padding: 0, margin: 0, width: '100%' }}
                        open={isLoading}
                      >
                        <CircularProgress sx={{color:'#810000'}}/>
                    </Backdrop>
                }
            	{
        			disclaimer && disclaimer?.length > 0 &&
	                <div 
	                    className='app-color mb-2 my-2' 
	                    dangerouslySetInnerHTML={{__html: disclaimer}}
	                ></div>
	            }                
                <iframe
                    onLoad={handleLoad}
                    src={url}                    
                    style={{width:'100%', height: '100%'/*, border:'1px solid black', borderRadius:'5px', borderColor: 'gray'*/}}
                ></iframe> 
            </DialogContent>
            <div className="modal-buttons">	            
	            {
	                download &&
	                <div className='me-1'>
	                    <DownloadIcon className='action-button-modal app-color' onClick={downloadFile}/>
	                </div>
	            }
	            <div className=''>
	                <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
	            </div>
	        </div>
        </Dialog>
    );
}